import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const Registration = ({ errors }) => {
  const reg = [...forms.adminPanelsDoctor.userEdit.registration];
  return (
    <div className="admin-patient-form-block">
      <span>Registration</span>
      <Row>
        {reg.map((field) => (
          <Col lg="12" md="12" sm="12" xs="12" key={field.id}>
            <Input dataCy={`users-input-${field.id}`} disabled {...field} />
            {errors[field.id] ? (
              <div className="input-error">
                {errors[field.id].split('.')[0]}
              </div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

Registration.propTypes = {
  errors: PropTypes.shape({}).isRequired,
};

export default Registration;
